// extracted by mini-css-extract-plugin
module.exports = {"faqs":"faqs-module--faqs--2zjrE","fontsLoading":"faqs-module--fonts-loading--e-M4E","faqsInner":"faqs-module--faqsInner---Gt0C"};